import React, { Component } from 'react';
import CouponInfoBody from './mycomponents/couponinfobody';
import Navbar from './mycomponents/navbar';

class CouponInfo extends Component {
    state = {  } 
    render() { 
        return (
            <React.Fragment>
                <Navbar/>
                <CouponInfoBody/>
            </React.Fragment>
        );
    }
}
 
export default CouponInfo;